(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-checkout-upsell"] && !Shopify.designMode) return;
  try {
    if (!window.ppCheckoutUpsellReady) {
    window.ppCheckoutUpsellReady = true;

    const SEEN_KEY = 'pp-checkout-upsell-seen';
    let bypass = false;

    const wasSeen = () => {
      try {
        return sessionStorage.getItem(SEEN_KEY) === '1';
      } catch (error) {
        return false;
      }
    };

    const markSeen = () => {
      try {
        sessionStorage.setItem(SEEN_KEY, '1');
      } catch (error) {
        /* Nur Komfortfunktion */
      }
    };

    const track = (name, detail) => {
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish(name, detail);
        }
      } catch (error) {
        /* Analytics duerfen nie stoeren */
      }
    };

    const goToCheckout = (trigger, dialog) => {
      bypass = true;
      if (trigger && trigger.isConnected && trigger.form) {
        trigger.form.requestSubmit(trigger);
      } else {
        window.location.href = (dialog && dialog.dataset.checkoutUrl) || '/checkout';
      }
    };

    const open = (dialog, trigger) => {
      const yes = dialog.querySelector('[data-pp-cu-yes]');
      const no = dialog.querySelector('[data-pp-cu-no]');
      const close = dialog.querySelector('[data-pp-cu-close]');
      const error = dialog.querySelector('[data-pp-cu-error]');

      markSeen();

      yes.onclick = async () => {
        yes.disabled = true;
        yes.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(dialog.dataset.addUrl || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: Number(dialog.dataset.variantId), quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('add failed');
          track('pp_upsell_add', { source: 'checkout_popup', variant: dialog.dataset.variantId });
          window.location.href = dialog.dataset.checkoutUrl || '/checkout';
        } catch (err) {
          error.hidden = false;
          window.setTimeout(() => goToCheckout(trigger, dialog), 1800);
        }
      };

      no.onclick = () => {
        track('pp_checkout_upsell_decline', {});
        dialog.close();
        goToCheckout(trigger, dialog);
      };

      close.onclick = () => dialog.close();
      dialog.onclick = (event) => {
        if (event.target === dialog) dialog.close();
      };

      dialog.showModal();
      yes.focus();
      track('pp_checkout_upsell_view', {});
    };

    document.addEventListener(
      'click',
      (event) => {
        if (bypass) return;
        const trigger = event.target.closest('button[name="checkout"]');
        if (!trigger || trigger.disabled || wasSeen()) return;

        const dialog = document.querySelector('dialog[data-pp-checkout-upsell]');
        if (!dialog || typeof dialog.showModal !== 'function') return;

        /* Nur anzeigen, wenn das Popup sichtbar werden kann (z. B. Warenkorb-Drawer ist offen) */
        const host = dialog.parentElement && dialog.parentElement.closest('dialog');
        if (host && !host.open) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        open(dialog, trigger);
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-rocket-fly"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ppRocketLanding) return;
    window.ppRocketLanding = true;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const ROCKET = /fly-to-cart--(main|quick|sticky)/;
    const BITS = ['★', '✦', '♥', '★', '✦', '♥', '★', '✦', '♥', '★', '✦', '♥', '✦', '★'];
    const COLORS = ['#e8303a', '#2f7cf0', '#ffd23f', '#ff8a1c'];

    const land = () => {
      const icon = document.querySelector('.header-actions__cart-icon');
      if (!icon) return;
      const r = icon.getBoundingClientRect();
      const x = r.left + r.width / 2;
      const y = r.top + r.height / 2;

      icon.classList.remove('pp-cart-land');
      void icon.offsetWidth;
      icon.classList.add('pp-cart-land');
      icon.addEventListener('animationend', () => icon.classList.remove('pp-cart-land'), { once: true });

      const add = (el) => {
        el.style.left = `${x}px`;
        el.style.top = `${y}px`;
        document.body.appendChild(el);
        el.addEventListener('animationend', () => el.remove(), { once: true });
      };

      const ring = document.createElement('span');
      ring.className = 'pp-land-fx pp-land-fx--ring';
      add(ring);

      BITS.forEach((char, i) => {
        const angle = (i / BITS.length) * Math.PI * 2 + Math.random() * 0.5;
        const dist = 45 + Math.random() * 35;
        const bit = document.createElement('span');
        bit.className = 'pp-land-fx pp-land-fx--bit';
        bit.textContent = char;
        bit.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
        bit.style.setProperty('--dy', `${Math.sin(angle) * dist}px`);
        bit.style.setProperty('--rot', `${Math.random() * 180 - 90}deg`);
        bit.style.setProperty('--size', `${15 + Math.random() * 10}px`);
        bit.style.setProperty('--color', COLORS[i % COLORS.length]);
        add(bit);
      });
    };

    const watch = () =>
      new MutationObserver((mutations) => {
        for (const m of mutations) {
          for (const node of m.removedNodes) {
            if (node.localName === 'fly-to-cart' && ROCKET.test(node.className)) land();
          }
        }
      }).observe(document.body, { childList: true });

    if (document.body) watch();
    else document.addEventListener('DOMContentLoaded', watch, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-ship-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-ship-countdown')) {
    class PpShipCountdown extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        if (window.ppDelivery) this.start();
        else document.addEventListener('pp:delivery-ready', () => this.start(), { once: true, signal });
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        clearInterval(this.timer);
      }

      start() {
        if (!this.isConnected || !window.ppDelivery) return;
        this.config = window.ppDelivery.readConfig(this);
        this.update();
        this.timer = setInterval(() => this.update(), 30000);
        document.addEventListener(
          'visibilitychange',
          () => {
            if (!document.hidden) this.update();
          },
          { signal: this.abortController.signal }
        );
      }

      update() {
        const core = window.ppDelivery;
        if (!core || !core.formatShipDay) return;
        const result = core.compute(this.config);
        const template = this.dataset.tplBefore;
        const values = {
          countdown: core.formatCountdown(result.minutesToCutoff ?? result.minutesLeft),
          shipday: core.formatShipDay(result.shipDate, result.today),
        };
        const parts = (template || '').split(/(\{countdown\}|\{shipday\})/);
        const text = this.querySelector('[data-text]');
        text.replaceChildren(
          ...parts.map((part) => {
            const key = part.slice(1, -1);
            if (!(part.startsWith('{') && key in values)) return part;
            const strong = document.createElement('strong');
            strong.textContent = values[key];
            return strong;
          })
        );
        this.hidden = false;
      }
    }

    customElements.define('pp-ship-countdown', PpShipCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
